// extracted by mini-css-extract-plugin
export default {"noContent":"NoContent_noContent__nHVnw","noContent_small":"NoContent_noContent_small__YyX7C","icon":"NoContent_icon__g+gMQ"};